import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withOktaAuth } from '@okta/okta-react';
import { message } from 'antd';
import {
  LOGOUT_ACTION,
  SET_SESSION_ACTION,
} from '../constants/ApplicationConstants';
import { notification } from 'antd';
import {
  GET_USER_PROFILE,
  PUT_INDV_SEED_ADVISORS,
  INDV_GROWER,
  MAKE_PAYMENT,
  PUT_DEFAULT_PROFILE,
} from '../constants/ApiConstants';
import { ApiHOC, MessageHOC } from '../shared';
import { parseJSON } from '../utilities/CommonApiUtils';
import messageIds from './messages';
import profileSelectionMessageIds from '../login/ProfileSelectionModal/messages';

import Landing from './Landing';
import {
  setUserDetail,
  setUserProfiles,
  setSelectedProfile,
  setDefaultProfile,
  setProfilesLoading,
} from '../login/action';
import {
  makeSelectUser,
  getUserMenus,
  makeSelectUserProfiles,
  makeSelectDefaultProfileId,
  makeSelectProfilesLoading,
  makeSelectNeedsProfileSelection,
} from '../login/selectors';
import {
  getCurrentCropYear,
  getUserTypeLogoutUrl,
} from '../utilities/UtilityFunctions';
import cookieMessageIds from '../common/CookieConsent/messages';
import { getSession, getSessionEmail } from '../security/session-selector';
import { markSsoSessionChecked } from '../security/ssoRedirect';
import { setSalesYear } from '../shared/components/financialYearSelector/store/action';
import { getSelectedSalesYear } from '../shared/components/financialYearSelector/store/selectors';
import {
  getSelectedUserProfileUrl,
  mapRoleToProfile,
  matchesProfileRef,
  clearActiveProfile,
} from './profileSelectionUtils';

const mapStateToProps = (
  state,
  { getMessages, commonMessages, userFromParent, saUuid }
) => {
  const formattedMsg = getMessages(messageIds);
  const formattedCookieMsg = getMessages(cookieMessageIds);
  const formattedProfileSelectionMsg = getMessages(profileSelectionMessageIds);
  return {
    messages: {
      ...formattedMsg,
      ...formattedCookieMsg,
      support_email: commonMessages.support_email,
      support_phone: commonMessages.support_phone,
    },
    profileSelectionMessages: formattedProfileSelectionMsg,
    user: makeSelectUser(state),
    menuItems: getUserMenus(state),
    session: getSession(state),
    sessionEmail: getSessionEmail(state),
    returnPage: userFromParent ? 'SA' : 'GROWER',
    saUuid: saUuid,
    salesYear: getSelectedSalesYear(state),
    userProfiles: makeSelectUserProfiles(state),
    defaultProfileId: makeSelectDefaultProfileId(state),
    profilesLoading: makeSelectProfilesLoading(state),
    needsProfileSelection: makeSelectNeedsProfileSelection(state),
  };
};

export const mergeProps = (stateProps, { dispatch }, ownProps) => {
  // Persists the default as a { type, salesForceId } ref (null to clear).
  // A 404 means a legacy user with no Contact record: feature unavailable, not an error to surface.
  const persistDefaultProfile = (profile) => {
    const { PUT } = ownProps;
    return PUT(
      PUT_DEFAULT_PROFILE,
      {
        default_profile: profile
          ? {
              type: profile.accountType,
              salesForceId: profile.salesForceId || null,
            }
          : null,
      },
      () => {},
      (err) => {
        console.warn(
          '[ProfileSelection] Failed to persist default profile:',
          err
        );
      }
    );
  };

  const logoutUser = async () => {
    const { oktaAuth } = ownProps;
    //clear the states
    clearActiveProfile();
    dispatch({ type: LOGOUT_ACTION });
    // signing out kills the Okta session, so the login page must not look for it again
    markSsoSessionChecked();
    await oktaAuth.signOut({
      postLogoutRedirectUri: window.location.origin + getUserTypeLogoutUrl(),
    });
  };

  const aggreeClick = async () => {
    //clear the states
    dispatch({ type: 'AGGREE' });
  };

  return {
    ...stateProps,
    ...ownProps,
    setUserProfile: (data) => dispatch(setUserDetail(data)),
    updateNotificationStatus: (userDtl) => {
      const { PUT } = ownProps;
      // notification["id"] = "34343455";
      return PUT(
        userDtl.userType === 'SEED_ADVISOR'
          ? PUT_INDV_SEED_ADVISORS(
              userDtl.seed_advisor_id !== undefined &&
                userDtl.seed_advisor_id !== null &&
                userDtl.seed_advisor_id !== ''
                ? userDtl.seed_advisor_id
                : 0
            )
          : INDV_GROWER(
              userDtl.grower_id !== undefined &&
                userDtl.grower_id !== null &&
                userDtl.grower_id !== ''
                ? userDtl.grower_id
                : 0
            ),
        {
          isAgreementComplete: userDtl.is_agreements_agreed,
          sales_force_id: userDtl.sales_force_id,
        },
        async (resp) => {
          try {
            const jsonResp = await parseJSON(resp);
            if (jsonResp.success || jsonResp.ok) {
              notification.success({
                placement: 'topRight',
                message: 'Agreements are read!',
              });
              ownProps.setSuccessMsg(true);
            }
          } catch (e) {
            console.log(`Error in parse ${e}`);
          }
        },
        () => {
          notification.error({
            placement: 'topRight',
            message: 'Error reading agreement notice',
          });
          ownProps.setErrorMsg(true);
        }
      );
    },
    loadUserDetail: (
      email,
      currUserType,
      seedAdvisorID,
      zdPartnershipUuid,
      salesForceId
    ) => {
      const { GET, commonMessages } = ownProps;
      sessionStorage.setItem('userEmail', email); //This is needed for payment when coming back from JPM because the stateProps will be undefined during that time

      const apiUrl = getSelectedUserProfileUrl({
        email,
        currUserType,
        seedAdvisorID,
        zdPartnershipUuid,
        salesForceId,
      });

      return GET(
        apiUrl,
        (resp) => {
          window.localStorage.removeItem('seed-advisor-id');
          window.localStorage.removeItem('zd-partnership-uuid');
          // console.log('JSON resp user profile');
          // console.log(JSON.stringify(resp));

          sessionStorage.setItem('userInfo', JSON.stringify(resp)); //This is needed for payment when coming back from JPM because the stateProps will be undefined during that time
          dispatch(setSalesYear(getCurrentCropYear()));
          dispatch(setUserDetail(resp));
        },
        (errResp) => {
          window.localStorage.removeItem('seed-advisor-id');
          window.localStorage.removeItem('zd-partnership-uuid');
          message.config({
            maxCount: 1,
          });
          message.error(commonMessages.server_error);
          setTimeout(() => {
            logoutUser();
          }, 3000);
        }
      );
    },
    logoutUser: logoutUser,
    aggreeClick: aggreeClick,
    setSession: (session) => {
      dispatch({
        type: SET_SESSION_ACTION,
        payload: { session },
      });
    },
    makePayment: (balance, cropYear, returnPage, saUuid) => {
      const { user, messages } = stateProps;
      const { POST } = ownProps;
      return POST(
        MAKE_PAYMENT,
        {
          productCode: 'Seeds',
          amountDue: balance?.toFixed(2),
          userId: user.grower_id,
          growerUuid: user.uuid,
          a1grower: user.first_name + ' ' + user.last_name,
          b1gnumber: '12345',
          d1busunit: 'Golden Advantage',
          returnSessionId: '12345',
          returnUrl: `${returnPage}/dashboard`,
          cropYear: cropYear,
          returnPage: returnPage,
          saUuid: saUuid,
        },
        async (resp) => {
          let result = await parseJSON(resp);
          if (result.sessionUrl) {
            return window.open(result.sessionUrl, '_self');
          }
          if (result.errorFlag) {
            return notification.error({
              placement: 'topRight',
              message: messages.error_message,
              duration: 0,
            });
          }
        }
      );
    },
    // Profile selection functions
    // Uses the existing GET_USER_PROFILE endpoint without type to get all available roles
    // `onError` sees a failed lookup before loading ends, so the caller can
    // stop the default "no profiles" flow (e.g. an inactive contact).
    loadUserProfiles: (email, onError) => {
      const { GET } = ownProps;
      dispatch(setProfilesLoading(true));
      return GET(
        GET_USER_PROFILE(email), // No type = returns all available roles
        (resp) => {
          // ApiHOC also calls this with null when the request fails, before
          // the error callback below; reading `roles` off null used to throw,
          // which skipped the error callback and froze the loading screen.
          if (!resp) return;
          // Transform roles array into profile objects for the modal
          // The backend returns roles as objects: { type, accountContactId, accountId, toolAdmin, accountName, address }
          const roles = resp.roles || [];

          if (roles.length === 0) {
            // No roles - no need for profile selection
            dispatch(setUserProfiles([]));
            dispatch(setProfilesLoading(false));
            return;
          }
          const profiles = roles.map((role, index) =>
            mapRoleToProfile(role, index, resp)
          );

          dispatch(setUserProfiles(profiles));
          // Backend returns the default as a { type, salesForceId } ref (or null); translate it to our internal id.
          const defaultRef = resp.default_profile;
          const defaultProfile = defaultRef
            ? profiles.find((p) => matchesProfileRef(p, defaultRef))
            : null;
          dispatch(
            setDefaultProfile(defaultProfile ? defaultProfile.id : null)
          );
          dispatch(setProfilesLoading(false));
        },
        (errResp) => {
          console.warn('Failed to load user profiles:', errResp);
          onError?.(errResp);
          dispatch(setProfilesLoading(false));
          dispatch(setUserProfiles([]));
        }
      );
    },
    onSelectProfile: (profile, setAsDefault) => {
      dispatch(setSelectedProfile(profile));
      if (setAsDefault && profile?.id) {
        dispatch(setDefaultProfile(String(profile.id)));
        persistDefaultProfile(profile);
      }
    },
    clearDefaultProfile: () => {
      dispatch(setDefaultProfile(null));
      persistDefaultProfile(null);
    },
  };
};

export default ApiHOC()(
  MessageHOC()(
    withRouter(
      withOktaAuth(connect(mapStateToProps, null, mergeProps)(Landing))
    )
  )
);
